import React from 'react';
import { Routes, Route, Navigate, NavLink as RouterNavLink } from 'react-router-dom';
import { Card, CardBody, Nav, NavItem, NavLink } from 'reactstrap';

import ManageAppAdverts from './ManageAppAdverts';
import AllApps from './AllApps';
import AdvertForm from './AdvertForm';
import InstalledSites from './InstalledSites';

/**
 * Manage Apps area (UN-3247/UN-3248): router-driven tabs over the P1-3 authoring API, with the advert
 * form and the installed-sites drill-down on their own routes.
 */
const ManageApps = () => {
  const tabs = [
    { path: '/manage-apps/adverts', label: 'Manage App Adverts' },
    { path: '/manage-apps/apps', label: 'All Apps' }
  ];

  return (
    <div className="animated fadeIn">
      <h2 className="mb-3">Manage Apps</h2>
      <Nav tabs className="mb-3">
        {tabs.map(tab => (
          <NavItem key={tab.path}>
            {/*
              `end` is load-bearing: RouterNavLink adds its own `active` class on a PREFIX match,
              so without it every /manage-apps/apps/* route lit "All Apps". Sub-screens — the advert
              form and each tab's installed-sites drill-down — light no tab; the breadcrumb names
              where you are.
            */}
            <NavLink tag={RouterNavLink} to={tab.path} end>
              {tab.label}
            </NavLink>
          </NavItem>
        ))}
      </Nav>
      <Card>
        <CardBody>
          <Routes>
            <Route index element={<Navigate to="adverts" replace />} />
            <Route path="adverts" element={<ManageAppAdverts />} />
            <Route path="apps" element={<AllApps />} />
            <Route path="adverts/new" element={<AdvertForm />} />
            <Route path="adverts/:uuid/edit" element={<AdvertForm />} />
            {/* One drill-down per tab's install count, each only the rows that count counted: All Apps
                lists every install of the app, Manage App Adverts only that advert's (UN-3252). Each is
                a modal on its own route rather than nested under its tab; closing walks history back
                to where it was opened (see InstalledSites.close). */}
            <Route path="apps/:uuid/installed-sites" element={<InstalledSites />} />
            <Route path="adverts/:uuid/installed-sites" element={<InstalledSites scope="advert" />} />
          </Routes>
        </CardBody>
      </Card>
    </div>
  );
};

export default ManageApps;
